export{VersionVariants}from"./variants.js";
//# sourceMappingURL=index.js.map
